import React,{useState} from 'react';
import ReactSelect from 'react-select'
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
const DeliverySection = ({ stockSymbols,NSEStockSymbols,BSEStockSymbols,requestToken,commenteryData,isEditable, onDeliverySectionChange,onDeliveryStockSelect,onRemoveFile}) => {
  


  const [deliverySectionState, setDeliverySectionState] = useState({
    deliveryReportType:'BUY',
    tradingsymbol:"NSE",
    stockType: '',
    deliveryCmp:'',
    deliveryRemark1: '',
    deliveryRemark2: '',
    deliverySL:'',
    commentry:'',
    Signal:'Buy'
  });

  let RemarkText = 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
  const nseoptions = NSEStockSymbols.map((data) => ({
    ...data,
    value: data.name,
    label: data.name,
  }));

  const bseoptions = BSEStockSymbols.map((data) => ({
    ...data,
    value: data.name,
    label: data.name,
  }));

  const CommenteryData = commenteryData.map((data)=>({
   ...data,
   value: data.Description,
   label: data.CommentaryName,
  }))
  const customStyles = {
    // Define your custom styles here
    menu: (provided) => ({
      ...provided,
      width: '256px',
      marginLeft:'185px'
    }),
    control: (provided, state) => ({
      ...provided,
      width: '256px', // Set the desired width for the entire component
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : null,
      '&:hover': {
        border: '1px solid #2684FF',
      },
    }),
    // Add more styles for other elements as needed
  };
  const [cmperror,setCmpError]=useState(false)
  const [slerror,setSlError]=useState(false)
 
  const [togglesymbol, setToggleSymbol] = useState(true);
  
// handleInputChange function to handle input changes
  const handleInputChange = (event) => {
    setCmpError(false);
    setSlError(false)
    const { name, value } = event.target;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
    setDeliverySectionState((prevState) => {
      
      let  newState 
      if(name === 'deliverySL' && value == '0'){
        
        newState = {
          ...prevState,
          [name]: value,
          deliveryRemark1:RemarkText
        };
      }
     else if(name === 'deliverySL' && value != '0'){
        
        newState = {
          ...prevState,
          [name]: value,
          deliveryRemark1:""
        };
      }
      else{
        newState = {
          ...prevState,
          [name]: value,
          deliveryRemark1:""
        };
      }
      // Notify the parent component about the change
      onDeliverySectionChange(newState);
  
      return newState;
    });
  } else {
    if(name === 'deliveryCmp'){
     setCmpError(true)
     setTimeout(() => {
      setCmpError(false)
    }, 2000);
    }
    if(name==='deliverySL'){
      setSlError(true)
      setTimeout(() => {
        setSlError(false)
      }, 2000);
    }
  }; 
  };

  // handleStockChange function to handle stock selection changes
  const handleStockChange = (event)=>{
    // const { name, value } = event.target;
  
    setDeliverySectionState((prevState) => {
      const newState = {
        ...prevState,
        stockType: event.value,
        deliveryCmp:"",
        deliveryRemark1:"",
        deliveryRemark2:"",
        deliverySL:'',
        commentry:"",
        Signal:"Buy"

      };

      onRemoveFile();
      let selectedStockRecord
      if(deliverySectionState.tradingsymbol === 'NSE'){
        selectedStockRecord = NSEStockSymbols.find(item => item.name === event.value);
      }
      else{
      selectedStockRecord = BSEStockSymbols.find(item => item.name === event.value);
    }
      
      onDeliveryStockSelect(selectedStockRecord);
      onDeliverySectionChange(newState);
  
      return newState;
    });
  }

  // handleChange function to handle radio button changes
  const handleChange = (event) => {
 
    const { name, value } = event.target;
  
    setDeliverySectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };
  
      // Notify the parent component about the change
      onDeliverySectionChange(newState);
  
      return newState;
    });
  
  };
  
   
// handleOptionChange function to handle select commmetry changes
  const handleOptionChange = (event) => {
    
    const { name, value } = event.target;
    const selectedValue = event.target.value;
  
    setDeliverySectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };
  
      // Notify the parent component about the change
      onDeliverySectionChange(newState);
      const selectedData = commenteryData.find((data) => data.Description === selectedValue);
      console.log("selectedData",selectedData); 
      return newState;
    });
  
  }

  // handleStockChangeManual function to handle stock changes manually using input field
  const handleStockChangeManual = async(event)=>{
    const{name,value} = event.target
    setDeliverySectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
        deliveryCmp:'',
        deliveryRemark1: '',
        deliveryRemark2: '',
        deliverySL:'',
        commentry:'',
        Signal:'Buy'
       
      };
  
      onRemoveFile();
   
      
      onDeliverySectionChange(newState);
      return newState;
    });
  }

  // handleToggleSymbolChange function to handle toggle switch changes
  const handleToogleSymbolChange = (event) => {

    event.preventDefault();
    // console.log("event.target.checked", event.target.checked);
    setToggleSymbol(event.target.checked);
    // setexpiryshow(false)
  
  };

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 30,
    height: 14,
    padding: 0,
    margin:'0 5px 0 -55px',
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #23499E",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 10,
      height: 10,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  return (
    <div className="deliverymain">
      <div id="btndeliveryreportDiv" className="btndeliveryreportdiv">
        <p>BUY</p>
        <input type="radio" value="BUY" defaultChecked name="buy" onChange={handleChange} />
        {/* <button type="button" onclick="submitForm()">Submit</button> */}
      </div>

       <div id="btndeliveryreportDiv" className="btndeliveryreportdiv">
        <p>NSE</p>
        <input type="radio" value="NSE" defaultChecked name="tradingsymbol" onChange={handleChange} />
        <p>BSE</p>
        <input type="radio" value="BSE" name="tradingsymbol" onChange={handleChange} />

      </div>

      <div className="deliverycontent">
        <div>
          <p>Stock Name:<span className='asterisk'>*</span></p>
          <IOSSwitch
                    sx={{ m: 1 }}
                    defaultChecked
                    checked={togglesymbol}
                    onChange={handleToogleSymbolChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
          {deliverySectionState.tradingsymbol === 'NSE'?
          
          togglesymbol?(<ReactSelect
          id="DeliveryStocktype" 
          name="stockType"
          options={nseoptions}
          onChange={handleStockChange}
          styles={customStyles}
          disabled={!isEditable}
          />):(
            <input value={deliverySectionState.stockType} type='text' id="stockType" name="stockType" required  onChange={handleStockChangeManual} disabled={!isEditable} />
            )
          :null}

          {deliverySectionState.tradingsymbol === 'BSE'?
          
         
          togglesymbol?(<ReactSelect
          id="DeliveryStocktype" 
          name="stockType"
          options={bseoptions}
          onChange={handleStockChange}
          styles={customStyles}
          disabled={!isEditable}
          />):(
            <input value={deliverySectionState.stockType} type='text' id="stockType" name="stockType" required  onChange={handleStockChangeManual}  disabled={!isEditable}/>
            )
           :null}
        </div>

      

        <div style={{marginTop:'16px'}}>
          <p>Signal:<span className='asterisk'>*</span></p>
          <select id="Signal" name="Signal" value={deliverySectionState.Signal} onChange={handleChange}  disabled={!isEditable}>
            <option value="">Select signal</option>
            <option value="Buy">Buy</option>
            <option value="Buy & Accumulate">Buy & Accumulate</option>
            <option value="Buy & Others">Buy & Others</option>
          </select>
        </div>


        {cmperror?<span style={{color:'red',fontSize:'15px'}}>Numeric input with 2 decimal places (0-9).</span>:null}
        

        <div>
          <p>CMP :<span className='asterisk'>*</span></p>
     
          <input value={deliverySectionState.deliveryCmp} type="number" id="deliveryCmp" name="deliveryCmp" required  onChange={handleInputChange}  disabled={!isEditable}/>
        </div>

        {slerror?<span style={{color:'red'}}>Numeric input with 2 decimal places (0-9).</span>:null}
        <div>
          <p>SL :</p>
          
          <input value={deliverySectionState.deliverySL} type="number" id="deliverySL" name="deliverySL" required  onChange={handleInputChange}  disabled={!isEditable}/>
        </div>

        <div>
          <p>Select commentary:<span className='asterisk'>*</span></p>
          <select value={deliverySectionState.commentry} id="selectcommentry" name="commentry" required onChange={handleOptionChange}  disabled={!isEditable}>
            <option value="">Select commentary</option>
            {commenteryData.map((data) => (
                      <option key={data.CommentaryName} value={data.Description}>
                        {data.CommentaryName}
                      </option>
                    ))}
          </select>
          
        </div>


        <div>
          <p>
           Commentary Remarks:
          </p>
         
          <textarea
          style={{
            border: `2px solid ${deliverySectionState.deliverySL === '0' ? 'red' : 'rgba(0, 0, 0, 0.2)'}`,
            outline: 'none',
          }}
          value={deliverySectionState.deliveryRemark1}
    id="deliveryRemark1"
    name="deliveryRemark1"
    required
    rows={4}
    onChange={handleChange} 
    disabled={!isEditable}
  />
        </div>
        <div>
          <p>
           Remarks:
          </p>
        
          <textarea
          value={deliverySectionState.deliveryRemark2}
    id="deliveryRemark2"
    name="deliveryRemark2"
    required
    rows={4} 
    onChange={handleChange}
    disabled={!isEditable}
  />
        </div>
      </div>

    </div>
  );
};

export default DeliverySection;
